import React from 'react';
import SanitizedHtml from 'src/components/ui/SafeHtml/SanitizedHtml';
import { useTranslation } from 'react-i18next';
import Modal from '../../layouts/Modal/Modal';
import Button, { ButtonToneProps } from '../../ui/Button/Button';

export type ConfirmActivationModalProps = {
  isOpen: boolean;
  onClose: (confirmed: boolean) => void;
  title: string | React.ReactNode;
  description: string | React.ReactNode;
};

const ConfirmationModal: React.FC<ConfirmActivationModalProps> = ({ isOpen, onClose, title, description }) => {
  const { t } = useTranslation();

  const handleContentClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
  };

  return (
    <div role="none" onClick={handleContentClick} onMouseDown={handleContentClick}>
      <Modal isOpen={isOpen} onClose={() => onClose(false)}>
        <div className="max-w-[400px] w-full">
          <div className="border-subtle-bottom p-32 flex flex-col mt-16">
            {typeof title === 'string' && <SanitizedHtml as="h4" className="mb-12 typo-title-24" html={title} />}
            {typeof title !== 'string' && <h4 className="mb-12 typo-title-24">{title}</h4>}

            {typeof description === 'string' && (
              <SanitizedHtml as="p" className="typo-text-16 text-faded" html={description} />
            )}
            {typeof description !== 'string' && <p className="typo-text-16 text-faded">{description}</p>}
          </div>
          <div className="border-subtle-bottom py-16 px-24 flex justify-end">
            <Button
              className="mr-12 !rounded-[8px]"
              onClick={() => onClose(false)}
              tone={ButtonToneProps.SECONDARY}
              title={t('general.cancel')}
            />
            <Button
              className="!rounded-[8px]"
              onClick={() => onClose(true)}
              tone={ButtonToneProps.PRIMARY_BLUE}
              title={t('general.confirm')}
            />
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default ConfirmationModal;
